import template from './employee_redirect.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeRedirectPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
	}

	async init()
	{
		window.current_page_title('');

		if (Permissions.isLoggedInUser_Accountant())
			Grape.navigate('#/payment_approval/payment');
		else if (Permissions.isLoggedInUser_Unverified())
			Grape.navigate('#/employee/view/' + Utils.current_employee_id()); // takes unverified user to their profile page to update
		else if (Permissions.isLoggedInUser_ExternalManager())
			Grape.navigate('#/employee/search/');
		else
			Grape.navigate('/employee/dashboard');
	}
}

export default {
	route: '[/]employee/redirect/',
	page_class: EmployeeRedirectPage,
	template: template,
	template_filename: 'translation/employee_redirect'
};
